import { render, staticRenderFns } from "./wd.vue?vue&type=template&id=467dc947&"
import script from "./wd.vue?vue&type=script&lang=js&"
export * from "./wd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports